// Funkcja walidacji hasła zgodna z aktualnymi standardami bezpieczeństwa
export const validatePassword = (password) => {
  const errors = [];
  
  // Minimum 8 znaków
  if (password.length < 8) {
    errors.push('Hasło musi mieć minimum 8 znaków');
  }
  
  // Co najmniej jedna wielka litera
  if (!/[A-Z]/.test(password)) {
    errors.push('Hasło musi zawierać co najmniej jedną wielką literę');
  }
  
  // Co najmniej jedna mała litera
  if (!/[a-z]/.test(password)) {
    errors.push('Hasło musi zawierać co najmniej jedną małą literę');
  }
  
  // Co najmniej jedna cyfra
  if (!/[0-9]/.test(password)) {
    errors.push('Hasło musi zawierać co najmniej jedną cyfrę');
  }
  
  // Co najmniej jeden znak specjalny
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push('Hasło musi zawierać co najmniej jeden znak specjalny (!@#$%^&*...)');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Funkcja sprawdzająca siłę hasła
export const getPasswordStrength = (password) => {
  if (!password) return { strength: 0, label: '' };
  
  let strength = 0;
  
  if (password.length >= 8) strength++;
  if (password.length >= 12) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/[0-9]/.test(password)) strength++;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength++;
  
  const labels = {
    0: '',
    1: 'Bardzo słabe',
    2: 'Słabe',
    3: 'Średnie',
    4: 'Dobre',
    5: 'Bardzo dobre',
    6: 'Mocne'
  };
  
  return {
    strength: Math.min(strength, 6),
    label: labels[Math.min(strength, 6)]
  };
};





